import styled from "@emotion/styled";
import { Affix, Button } from "antd";
import { FC } from "react";
import { useNavigate } from "react-router-dom";

interface FooterShippingProps {
  loading?: boolean;
}

const FooterShipping: FC<FooterShippingProps> = ({ loading }) => {
 const navigate = useNavigate();

  return (
    <Affix offsetBottom={0}>
      <WrapperAll>
        <ButtonWrapper>
          <Button
            htmlType="submit"
            type="primary"
            style={{ width: 200 }}
            size="middle"
            onClick={ ()=> {
              navigate('/manage-shipping/create')
            }}
          >
            เพิ่มค่าส่งใหม่
          </Button>
        </ButtonWrapper>
      </WrapperAll>
    </Affix>
  );
};

export default FooterShipping;
const ButtonWrapper = styled.div`
  max-width: 250px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`;

const WrapperAll = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  padding: 4px;
  background-color: #fff;
  border-radius: 4px;
`;
